module.exports = __webpack_public_path__ + "static/25-b9cd8f252e6bf05be54e562201ccb9ae.png";